import React, { createContext, useContext } from "react";

const PlannerContext = createContext(null);

export function PlannerProvider({ value, children }) {
  return (
    <PlannerContext.Provider value={value}>
      {children}
    </PlannerContext.Provider>
  );
}

export function usePlannerContext() {
  const ctx = useContext(PlannerContext);

  if (!ctx) {
    throw new Error("usePlannerContext must be used inside PlannerProvider");
  }

  return ctx;
}